module.exports = __webpack_public_path__ + "media/images/lp/support-ashinaga1-pc-17d023f2f5854e5242b48b27adf3f6bd.png";